export const comments_5689020 = {"data":{"data":[],"links":{}}}